import React from 'react';
import { Switch, Route } from 'react-router-dom';
import withOnboarding from './withOnboarding';

class OnboardingSubmitContainer extends React.Component {
  render() {
    return (
      <Switch className="on-boarding__cta">
        {this.props.steps.map(
          (
            { path, submitComponent: SubmitComponent, submitProps = {} },
            index
          ) => (
            <Route
              key={index}
              exact
              path={path}
              render={() => <SubmitComponent {...submitProps} />}
            />
          )
        )}
      </Switch>
    );
  }
}
export default withOnboarding(OnboardingSubmitContainer);



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingSubmitContainer.js